import { axios, createFormData, handleError } from '../axios';

export const memberUpdateProfile = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('member/profile/info', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
